<div class="truck-info-panel">
  <sc-flex >
    <div class="icon">
      <sc-icon iconClass="fa-truck-flatbed"></sc-icon>
    </div>
    <sc-content-spacer></sc-content-spacer>
    <div class="information">
      <div class="label">
        <sc-dictionary-label dictionaryKey="tmc-yard.entity.truck.carrier"></sc-dictionary-label>
      </div>
      <div class="value">{{carrier}}</div>
    </div>
    <sc-content-spacer></sc-content-spacer>
    <div class="information">
      <div class="label">
        <sc-dictionary-label dictionaryKey="tmc-yard.entity.truck.numberplate"></sc-dictionary-label>
      </div>
      <div class="value">{{identifier}}</div>
    </div>
    <sc-content-spacer></sc-content-spacer>
    <div class="information">
      <div class="label">
        <sc-dictionary-label dictionaryKey="tmc-yard.entity.truck.driver"></sc-dictionary-label>
      </div>
      <div class="value">{{driver}}</div>
    </div>
    <sc-content-spacer grow></sc-content-spacer>
  </sc-flex>
</div>
